import { Component } from '@angular/core';

@Component({
  selector: 'wun-papers-icon',
  standalone: true,
  imports: [],
  templateUrl: './papers-icon.component.svg',
  styleUrl: './papers-icon.component.scss'
})
export class PapersIconComponent {

}
